import { useSelector } from 'react-redux';

 
import { getPricesWithQuoteAsset } from '../../redux/selectors';
import { PricesWithQuoteAsset } from '../../redux/slices';

export const usePricesWithQuoteAsset = (): PricesWithQuoteAsset => {
  const pricesWithQuoteAsset = useSelector(getPricesWithQuoteAsset);

  return pricesWithQuoteAsset;
};
